import { IAMSettings, iamType } from 'apprise-core/iam'
import { useEnv } from 'apprise-frontend-core/env'
import { useT } from 'apprise-frontend-core/intl/language'
import { useSettings } from 'apprise-frontend-streams/settings/api'
import { SettingRenderProps, SettingsModule } from 'apprise-frontend-streams/settings/model'
import { Form } from 'apprise-ui/form/form'
import { SwitchBox } from 'apprise-ui/switchbox/switchbox'
import { useLogged } from './login/logged'
import { UserIconFull } from './user/constants'
import { UserMultiBox } from './user/userbox'




export const useIAMSettings = () => useSettings<IAMSettings>(iamType)


// a policy that enables selected features in production builds for a number of designated beta testers.
// if there are no beta-testers all the features are enabled in development builds.
export const useIsFeatureEnabledForBetaTester = (toggles: string[]) => {

    const env = useEnv()

    const logged = useLogged()

    const { betaTesters } = useIAMSettings()

    return {

        isFeatureEnabled: (toggle: string) => {

            // extends default opt-out policy: what's mentioned is off.
            if (!toggles.includes(toggle))
                return true

            const betatester = betaTesters?.length ? betaTesters.includes(logged.username) : env.name !== 'production'

            return betatester

        }
    }
}


export const IAMSettingsPanel = (props: SettingRenderProps<IAMSettings>) => {

    const { onChange, settings } = props

    const fields = useIAMSettingsFields()

    return <Form>

        <UserMultiBox info={fields.betaTesters} onChange={betaTesters => onChange({ ...settings, betaTesters: betaTesters ?? [] })} >
            {settings.betaTesters}
        </UserMultiBox>
        
        <SwitchBox info={fields.disableRemoval} onChange={disableRemoval => onChange({ ...settings, disableTenantRemoval: !!disableRemoval })} >
            {settings.disableTenantRemoval}
        </SwitchBox>

        <SwitchBox info={fields.retrieveAllUserReferences} onChange={retrieveAllUserReferences => onChange({ ...settings, retrieveAllUserReferences: !!retrieveAllUserReferences })} >
            {settings.retrieveAllUserReferences}
        </SwitchBox>

    </Form>
}


const useIAMSettingsFields = () => {

    const t = useT()

    return {

        betaTesters: {

            label: t('user.betatester_lbl'),
            msg: t('user.betatester_msg'),
            help: t('user.betatester_help')
        }
        ,

        disableRemoval: {

            label: t('tenant.disable_removal_lbl'),
            msg: t('tenant.disable_removal_msg'),
            help: t('tenant.disable_removal_help')
        }



        ,

        retrieveAllUserReferences: {

            label: t('tenant.retrieve_allrefs_lbl'),
            msg: t('tenant.retrieve_allrefs_msg'),
            help: t('tenant.retrieve_allrefs_help')
        }

    }
}


export const useIAMSettingsModule = (): SettingsModule<IAMSettings> => {


    return {

        Icon: UserIconFull,
        name: "IAM",
        type: iamType,
        defaults: {
            disableTenantRemoval: false,
            retrieveAllUserReferences: false
        },
        Render: IAMSettingsPanel,
        fields: useIAMSettingsFields

    }

}
